module.exports = __webpack_public_path__ + "static/jaroslav-suchy-ecbdcb287e9653f4d21bc187371fce9a.jpg";